import { css } from "styled-components"

export const sizes = {
  fromDesktop: 1460,
  fromTablet: 1220,
  fromPhone: 850,
  phone: 850,
  tablet: 850
}

export const { tablet, phone, fromPhone, fromTablet, fromDesktop } = sizes

export default {
  tablet: (...args) => css`
    @media (max-width: ${tablet}px) {
      ${css(...args)}
    }
  `,
  phone: (...args) => css`
    @media (max-width: ${phone}px) {
      ${css(...args)}
    }
  `,
  fromTablet: (...args) => css`
    @media (min-width: ${fromTablet}px) {
      ${css(...args)}
    }
  `,
  fromDesktop: (...args) => css`
    @media (min-width: ${fromDesktop}px) {
      ${css(...args)} )
    }
  `,
  fromPhone: (...args) => css`
    @media (min-width: ${fromPhone}px) {
      ${css(...args)} )
    }
  `
}
